"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryClient, QueryClientProvider as TanstackQueryClientProvider } from "@tanstack/react-query";
import type { ReactNode } from "react";
type ProvidersProps = {
  children: ReactNode;
};
let browserQueryClient: QueryClient | undefined;
const getQueryClient = () => {
  if (!browserQueryClient) {
    browserQueryClient = new QueryClient({
      defaultOptions: {
        queries: {
          // Server-hydrated queries (product, pricing, Trustpilot) were refetched on every
          // mount under the default staleTime of 0, duplicating a ~600ms PAS fetch per PDP view.
          staleTime: 60_000
        }
      }
    });
  }
  return browserQueryClient;
};
export function QueryClientProvider(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getQueryClient();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const queryClient = t1;
  let t2;
  if ($[1] !== children) {
    t2 = <TanstackQueryClientProvider client={queryClient}>{children}</TanstackQueryClientProvider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}